import { render, staticRenderFns } from "./paymentReturn.vue?vue&type=template&id=8fa1e4c2&scoped=true&"
import script from "./paymentReturn.vue?vue&type=script&lang=js&"
export * from "./paymentReturn.vue?vue&type=script&lang=js&"
import style0 from "./paymentReturn.vue?vue&type=style&index=0&id=8fa1e4c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fa1e4c2",
  null
  
)

export default component.exports